/* eslint-disable @typescript-eslint/ban-types */
import { Action, ActionReducer, INIT } from '@ngrx/store';
import { Logger } from '@mona/shared/logger';
import { pick } from '@mona/shared/utils';
import { AppState } from './state/index.state';

/**
 * Amend the initial state with the stored state and return it
 * @param initialState initialState
 * @returns Any
 */
export function mergeWithStoredState<T>(initialState): T {
    const storedData = { state: {} }; // getHmrData();
    return storedData && storedData.state
        ? {
              ...initialState,
              ...storedData.state,
          }
        : initialState;
}

/**
 * Initial state factory
 * @param initialReducer initialReducer
 * @param reducerFactory reducerFactory
 */
export function initialStateFactory(initialReducer, reducerFactory) {
    return mergeWithStoredState<AppState>(reducerFactory(initialReducer)(undefined, { type: INIT }));
}

/**
 * A meta reducer used for clearing app state on logout
 * @param reducer reducer
 */
export function clearState(reducer) {
    return function (state, action) {
        const assignedEncounterId = localStorage.getItem('pdms.assignedEncounterId');
        const isElectron = window.electron !== undefined;

        if (action.type === 'APP_STATE:CLEAR_STATE') {
            state = isElectron // TODO: do we need to clear specific if assigned encounter on/off ?
                ? { ...state }
                : pick(state, 'config', 'ui', 'api', 'auth', 'router', 'device', 'terminology');
        }

        return reducer(state, action);
    };
}

export const ACTIONS_BLOCK_LIST = ['@ngrx/store/init', '@ngrx/store-devtools/recompute'];

export const ACTIONS_SKIP_LIST = [
    '@ngrx/store/init',
    '@ngrx/effects/init',
    '@ngrx/store-devtools/recompute',
    '@ngrx/store/update-reducers',
    '@ngrx/router-store/navigation',
    '@ngrx/router-store/request',
    'API:LOAD_HEALTH',
    'API:LOAD_HEALTH_SUCCESS',
];

/**
 * Lightweight production logger — logs action.type always, error.message
 * on failure actions only. Never serializes full payload (that was the root
 * cause of multi-second UI freezes on large entity collections — MD-11758).
 * @param reducer
 */
export function actionTypeLogger(reducer: ActionReducer<AppState>): ActionReducer<AppState> {
    const log = new Logger('STATE');
    return function (state: AppState, action: Action): AppState {
        if (ACTIONS_SKIP_LIST.includes(action.type) || action.type === 'EMPTY') {
            return reducer(state, action);
        }
        const typeLower = action.type.toLowerCase();
        if (typeLower.endsWith('failure') || typeLower.endsWith('failed')) {
            const errorMsg = (action as AnyObject)?.error?.message ?? (action as AnyObject)?.error ?? '';
            log.log(action.type, errorMsg);
        } else {
            log.log(action.type);
        }
        return reducer(state, action);
    };
}

export const META_REDUCERS = [clearState, actionTypeLogger];
